import { Box, CircularProgress } from "@mui/material";

export function FullScreenSpinner() {
  return (
    <Box sx={{ height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <CircularProgress />
    </Box>
  );
}
